import type { Character, CollectionResponse } from '@guildrise/shared';
import { CollectionCard } from '../../shared/ui/collection-card.js';
import { ErrorState, Skeleton } from '../../shared/ui/controls.js';
import { useCollection } from './use-collection.js';
import './collection.css';

export function CollectionScreen({
  guildId,
  catalog,
}: {
  readonly guildId: string;
  readonly catalog: readonly Character[];
}): React.ReactElement {
  const { state, retry } = useCollection(guildId);
  if (state.status === 'loading') {
    return (
      <section aria-label="Загрузка коллекции" aria-busy="true">
        <Skeleton variant="title" />
        <Skeleton variant="card" />
      </section>
    );
  }
  if (state.status === 'error') {
    return <ErrorState title="Коллекция недоступна" message={state.message} onRetry={retry} />;
  }
  return <CollectionContent collection={state.collection} catalog={catalog} />;
}

export function CollectionContent({
  collection,
  catalog,
}: {
  readonly collection: CollectionResponse;
  readonly catalog: readonly Character[];
}): React.ReactElement {
  const byId = new Map(catalog.map((character) => [character.character_id, character]));
  return (
    <section className="collection enter" aria-label="Коллекция">
      <h1 className="h2">Коллекция</h1>
      {collection.characters.length === 0 ? (
        <p className="body">В коллекции пока нет карт.</p>
      ) : (
        <ul className="collection__grid">
          {collection.characters.map((owned) => {
            const character = byId.get(owned.characterId);
            return (
              <li key={owned.id}>
                {character ? (
                  <CollectionCard character={character} />
                ) : (
                  <p className="hint">Данные карты недоступны: {owned.characterId}</p>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
